<template>
  <v-navigation-drawer
    v-model="drawer"
    permanent
    width="350"
    class="o-nav pa-5"
    app
    clipped
  >
    <div class="mx-3 mt-5 mb-4 font-weight-bold text-uppercase">
      <div>Member Tools</div>
    </div>
    <v-list dense>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="mb-3">
            <v-icon small :class="`mr-2 mb-2 ${isActiveRoute('intro') ? 'o-navIcon--active': 'o-navIcon'}`">fas fa-circle fa-fw</v-icon>
            <a :class="`o-sectionLink ${isActiveRoute('intro') ? 'o-nav--active' : 'o-nav'}`" href="/build/intro">Introduction</a>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>


      <!-- <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="mb-3">
            <v-icon small class="mr-2 mb-2 o-navIcon">fas fa-circle fa-fw</v-icon>
            <a class="o-sectionLink o-nav" :href="`/member/${saDisplayNameEncoded}/kpi`">KPIs</a>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="mb-3">
            <v-icon small :class="`mr-2 mb-2 ${isActiveRoute('compassRoseBuild') ? 'o-navIcon--active': 'o-navIcon'}`">fas fa-circle fa-fw</v-icon>
            <a :class="`o-sectionLink ${isActiveRoute('compassRoseBuild') ? 'o-nav--active' : 'o-nav'}`" href="/build/compass-rose/view">Compass Rose</a>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      
      <v-list-item
        v-for="item in filteredSectionList"
        :key="item.name"
        :index="item.index"
        dense
      >
        <v-list-item-content>
          <v-list-item-title class="mb-3">
            <v-icon
              small
              :class="`mr-2 mb-2 ${
                isActiveRoute(item.route)
                  ? 'o-navIcon--active'
                  : 'o-navIcon'
              }`"
              >fas fa-circle fa-fw</v-icon
            >
            <router-link :to="{ name: item.route }" v-slot="{ href }"
              ><a
                :class="`o-sectionLink ${
                  isActiveRoute(item.route) ? 'o-nav--active' : 'o-nav'
                }`"
                :href="href"
                :data-cy="camelCase(`buildNav ${item.label}`)"
                >{{ item.label }}</a
              >
            </router-link>
          </v-list-item-title>
          <v-list dense v-if="item.subsectionList && isActiveRoute(item.route)">
            <v-list-item
              v-for="subItem in item.subsectionList"
              :key="subItem.name"
              :index="subItem.index"
              dense
              :class="`och-nav__subItem ${
                isActiveRoute(subItem.route) ? 'och-nav__subItem--active' : ''
              }`"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <router-link
                    :to="{ name: subItem.route }"
                    :class="`o-sectionLink ${
                      isActiveRoute(subItem.route)
                        ? 'o-nav--active'
                        : 'o-nav'
                    }`"
                    >{{ subItem.label }}</router-link
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="mb-3">
            <v-icon small :class="`mr-2 mb-2 ${isActiveRoute('departmentBuild') ? 'o-navIcon--active': 'o-navIcon'}`">fas fa-circle fa-fw</v-icon>
            <a :class="`o-sectionLink ${isActiveRoute('departmentBuild') ? 'o-nav--active' : 'o-nav'}`" href="/build/department/list">Departments</a>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      
      <v-list-item v-if="typeof organization !== 'undefined' && organization.careSetting === 'Ambulatory'">
        <v-list-item-content>
          <v-list-item-title class="mb-3">
            <v-icon small :class="`mr-2 mb-2 ${isActiveRoute('organizationRoleApp') ? 'o-navIcon--active': 'o-navIcon'}`">fas fa-circle fa-fw</v-icon>
            <a :class="`o-sectionLink ${isActiveRoute('organizationRoleApp') ? 'o-nav--active' : 'o-nav'}`" href="/build/role/list">Security Roles</a>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="mb-3">
            <v-icon small :class="`mr-2 mb-2 ${isActiveRoute('userBuild') ? 'o-navIcon--active': 'o-navIcon'}`">fas fa-circle fa-fw</v-icon>
            <a :class="`o-sectionLink ${isActiveRoute('userBuild') ? 'o-nav--active' : 'o-nav'}`" href="/build/user/list">Users</a>
          </v-list-item-title>
          <v-list dense>
            <v-list-item dense class="och-nav__subItem">
              <v-list-item-content>
                <v-list-item-title>
                  <a class="o-sectionLink o-nav" :href="`/member/${saDisplayNameEncoded}/user/training`">Training</a>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-list-item-content>
      </v-list-item>
      
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="mb-3">
            <v-icon small :class="`mr-2 mb-2 ${isActiveRoute('resourceBuild') ? 'o-navIcon--active': 'o-navIcon'}`">fas fa-circle fa-fw</v-icon>
            <a :class="`o-sectionLink ${isActiveRoute('resourceBuild') ? 'o-nav--active' : 'o-nav'}`" href="/build/resource/list">Resources</a>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    
    <template v-if="isOchinUser">
      <v-divider class="mb-5"></v-divider>
      <div class="mx-3 mt-8 mb-4 font-weight-bold text-uppercase">
        <div>OCHIN Tools</div>
      </div>
      <v-list dense data-test="ochin-admin-menu">
        <v-list-item dense>
          <v-list-item-content>
            <v-list-item-title class="mb-3">
              <v-icon small class="mr-2 mb-2 o-navIcon">fas fa-circle fa-fw</v-icon>
              <a class="o-sectionLink o-nav" :href="`/member/${saDisplayNameEncoded}/entra-sync`">Entra Sync</a>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item dense>
          <v-list-item-content>
            <v-list-item-title class="mb-3">
              <v-icon small :class="`mr-2 mb-2 ${
                  isActiveRoute('exportBilling')
                    ? 'o-navIcon--active'
                    : 'o-navIcon'
                }`">fas fa-circle fa-fw</v-icon>
              <a :class="`o-sectionLink ${
                  isActiveRoute('exportBilling')
                    ? 'o-nav--active'
                    : 'o-nav'
                }`" href="/build/export/billing">Billing and Finance</a>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item dense>
          <v-list-item-content>
            <v-list-item-title class="mb-3">
              <v-icon small :class="`mr-2 mb-2 ${
                  isActiveRoute('exportUser')
                    ? 'o-navIcon--active'
                    : 'o-navIcon'
                }`">fas fa-circle fa-fw</v-icon>
              <a :class="`o-sectionLink ${
                  isActiveRoute('exportUser')
                    ? 'o-nav--active'
                    : 'o-nav'
                }`" href="/build/export/user">User Export v1</a>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item dense>
          <v-list-item-content>
            <v-list-item-title class="mb-3">
              <v-icon small :class="`mr-2 mb-2 ${
                  isActiveRoute('exportUser')
                    ? 'o-navIcon--active'
                    : 'o-navIcon'
                }`">fas fa-circle fa-fw</v-icon>
              <a :class="`o-sectionLink ${
                  isActiveRoute('exportUser')
                    ? 'o-nav--active'
                    : 'o-nav'
                }`" :href="`/member/${saDisplayNameEncoded}/ochin-user`">User Export v2 (Coming Soon!)</a>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item dense>
          <v-list-item-content>
            <v-list-item-title class="mb-3">
              <v-icon small :class="`mr-2 mb-2 ${
                  isActiveRoute('exportResource')
                    ? 'o-navIcon--active'
                    : 'o-navIcon'
                }`">fas fa-circle fa-fw</v-icon>
              <a :class="`o-sectionLink ${
                  isActiveRoute('exportResource')
                    ? 'o-nav--active'
                    : 'o-nav'
                }`" href="/build/export/resource">Resource</a>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item dense>
          <v-list-item-content>
            <v-list-item-title class="mb-3">
              <v-icon small :class="`mr-2 mb-2 ${
                  isActiveRoute('exportStructure')
                    ? 'o-navIcon--active'
                    : 'o-navIcon'
                }`">fas fa-circle fa-fw</v-icon>
              <a :class="`o-sectionLink ${
                  isActiveRoute('exportStructure')
                    ? 'o-nav--active'
                    : 'o-nav'
                }`" href="/build/export/export/structure">Structure</a>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { camelCase } from "lodash";

export default {
  computed: {
    filteredSectionList() {
      const { organization, sectionList } = this;

      if (!organization || !sectionList) {
        return [];
      }

      if (typeof organization !== "undefined" && organization.careSetting === "Acute Care") {
        return sectionList.filter(x => x.acute);
      }

      return sectionList.filter(x => x.ambulatory);
    },
    memberAdminFlag() {
      if (!this.flagMap) {
        return false;
      }
      return this.flagMap.memberAdmin;
    },
    organization() {
      const { getOrganizationById, organizationId } = this;
      if (!organizationId) {
        return;
      }
      return getOrganizationById(organizationId);
    },
    routeFullPath() {
      return this.$route.fullPath;
    },
    saDisplayNameEncoded() {
      return encodeURIComponent(`ochin-crowd-sa${this.saNumber}`);
    },
    sectionListMemberAdmin() {
      return !this.memberAdminFlag
        ? []
        : [
            {
              label: "Addresses",
              route: "buildMemberAdminAddressList",
            },
            {
              label: "Users",
              route: "buildMemberAdminUserList",
            },
          ];
    },
    ...mapGetters({
      flagMap: "featureFlag/getFlagMap",
      getOrganizationById: "organization/getById",
    }),
    ...mapState({
      isMemberAdmin: state => !!state.session.user.permission.user.memberAdmin,
      isOchinUser: state => !!state.session.isOchinUser,
      organizationId: state => state.session.organizationId,
      saNumber: state => state.session.serviceArea,
    }),
  },
  async created() {
    if (this.organization) {
      return;
    }

    try {
      await this.loadOrganization();
    } catch (e) {
      console.error(e);
      this.$notify("Unable to load organization data");
    }
  },
  data() {
    return {
      drawer: true,
      sectionList: [
        {
          label: "Structure",
          route: "buildStructureApp",
          acute: true,
          ambulatory: true,
          subsectionList: [
            {
              acute: true,
              ambulatory: true,
              label: "Chart",
              route: "structureChart",
            },
            {
              acute: true,
              ambulatory: true,
              label: "List",
              route: "structureList",
            },
          ],
        },
      ],
    };
  },
  methods: {
    camelCase,
    filterSubSectionList(subsectionList) {
      const { organization } = this;

      if (!organization || !subsectionList) {
        return [];
      }

      if (typeof organization !== "undefined" && organization.careSetting === "Acute Care") {
        return subsectionList.filter(x => x.acute);
      }

      return subsectionList.filter(x => x.ambulatory);
    },
    isActiveRoute(name) {
      return this.$route.matched.find(route => {
        return route.name === name;
      });
    },
    ...mapActions({
      loadOrganization: "organization/list",
    }),
  },
};
</script>

<style>
.o-nav {
  color: #595959 !important;
}

.o-subsection.v-list-item {
  margin-top: -10px;
}

.o-navIcon {
  color: #ccc !important;
}

.o-navIcon--active {
  color: var(--v-secondary-base) !important;
}

.o-nav--active {
  color: var(--v-primary-base) !important;
  font-weight: bold;
}

.o-sectionLink {
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: bold;
}

.o-subsectionLink {
  text-decoration: none;
  font-size: 1rem;
}

.o-subsection {
  border-left: 2px solid var(--v-primary-base);
  padding-left: 2.1rem !important;
}

.och-nav__subItem {
  border-left: 2px solid var(--v-primary-base);
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 8px;
  padding-left: 25px;
}

.och-nav__subItem a {
  color: grey;
  font-size: 16px !important;
}

.och-nav__subItem--active a {
  color: var(--v-primary-base);
}
</style>
